import ASLogo from "@/components/graphics/ASLogo";
import SystemBrand from "@/components/graphics/SystemBrand";
import AppSwitcher from "@/components/layouts/AppSwitcher";
import NavbarUserMenu from "@/components/layouts/NavbarUserMenu";
import { useNavbarUserMenu } from "@/hooks/useNavbarUserMenu";
import { FileText, Home, Scale } from "lucide-react";
import { NavLink } from "react-router";

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  `cle-compliance-nav__link nav-link d-inline-flex align-items-center gap-2 fs-6 rounded-3 px-3 py-2 lh-sm ${
    isActive ? "active fw-semibold " : ""
  }`;

const CleComplianceNavbar = () => {
  const { userInfo } = useNavbarUserMenu();

  return (
    <header
      className="navbar app-navbar px-4 py-2 bg-white sticky-top position-sticky flex-nowrap navbar--shadow"
      aria-label="Efteruddannelse navigation"
    >
      <div className="d-flex align-items-center gap-3 flex-shrink-0 app-navbar__brand">
        <a
          className="text-logo d-flex align-items-center"
          target="_blank"
          rel="noreferrer"
          href="https://www.advokatsamfundet.dk/"
          aria-label="Advokatsamfundet"
        >
          <ASLogo height={42} />
        </a>
        <span className="app-navbar__divider" />
        {userInfo?.role === "TokenUser" ? <SystemBrand /> : <AppSwitcher />}
      </div>

      <div className="d-flex align-items-center gap-3 ms-auto flex-shrink-0 app-navbar__actions">
        <ul className="nav cle-compliance-nav gap-1 flex-row flex-wrap align-items-center mb-0">
          <li className="nav-item">
            <NavLink id="cle-nav-hjem" to="." end className={navLinkClass}>
              <span className="cle-compliance-nav__icon" aria-hidden="true">
                <Home size={18} strokeWidth={2} />
              </span>
              <span>Hjem</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              id="cle-nav-indberetninger"
              to="indberetninger"
              className={navLinkClass}
            >
              <span className="cle-compliance-nav__icon" aria-hidden="true">
                <FileText size={18} strokeWidth={2} />
              </span>
              <span>Indberetninger</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              id="cle-nav-afgorelser"
              to="afgorelser"
              className={navLinkClass}
            >
              <span className="cle-compliance-nav__icon" aria-hidden="true">
                <Scale size={18} strokeWidth={2} />
              </span>
              <span>Afgørelser</span>
            </NavLink>
          </li>
        </ul>
        <span className="app-navbar__divider" />
        <NavbarUserMenu />
      </div>
    </header>
  );
};

export default CleComplianceNavbar;
